<div class="depth-container" *ngIf="isDepthEnabled() && depthUnitForm">
    <label for="depth-input">{{ title() }}</label>
    <form class="depth-form" [formGroup]="depthUnitForm">
        <input id="depth-input" class="form-control mr-2" type="number" formControlName="depth" />
        <div class="depth-span">
            <select name="depth-select" class="form-control" required formControlName="depthUnit">
                <option *ngFor="let depthUnitDisplay of depthUnits()" [value]="depthUnitDisplay">{{ depthUnitDisplay }}</option>
            </select>
        </div>
    </form>
</div>
